<template>
   <results-wrapper>
      <el-tabs class="bat-results" v-model="activeName"  @tab-click="handleClick">
         <el-tab-pane label="Scenario" name="scenario">
            <scenario/>
         </el-tab-pane>
         <el-tab-pane label="Result" name="result">
            <combined-graph/>
         </el-tab-pane>
         <el-tab-pane label="Comparison Curve" name="comparison-curve">
            <comparison-graph/>
         </el-tab-pane>
         <el-tab-pane label="LCOE" name="lcoe">
            <lcoe-graph/>
         </el-tab-pane>
         <el-tab-pane label="Ratio Curve" name="ratio-curve">
            <ratio-graph/>
         </el-tab-pane>
         <el-tab-pane label="BAT" name="bat">
            <bat-analysis/>
         </el-tab-pane>
      </el-tabs>
   </results-wrapper>
</template>

<script>
import { Tabs,TabPane } from 'element-ui';
import Scenario from './Scenario';
import CombinedGraph from './CombinedGraph';
import ResultsWrapper from '../../../molecules/Home/ResultsWrapper';
import ComparisonGraph from './ComparisonGraph';
import LcoeGraph from './LcoeGraph';
import RatioGraph from './RatioGraph';
import BatAnalysis from './BatAnalysis';

export default {
   components: {
      'el-tabs': Tabs,
      'el-tab-pane': TabPane,
      Scenario,
      CombinedGraph,
      ComparisonGraph,
      LcoeGraph,
      RatioGraph,
      BatAnalysis,
      ResultsWrapper,
   },
   data() {
      return {
         activeName: 'scenario'
      };
   },
   methods: {
      handleClick(tab)
      {
         const tabsWithChart = ['result', 'comparison-curve', 'lcoe', 'ratio-curve'];
         if (tabsWithChart.includes(tab.name))
         {
            // dispatch resize event to charts resize to appropriate size
            window.dispatchEvent(new Event('resize'));
         }
      }
   }
};
</script>
